const cargos = state => state.cargos;
const tipocargo = state => state.tipocargo;
const series = state => state.series;
const caja = state => state.caja;
export default {
  cargos,
  series,
  tipocargo,
  caja,
};